var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market" },
    [
      _c(
        "div",
        { staticClass: "market__header" },
        [
          _c("div", [
            _c("h2", { staticClass: "market__title" }, [
              _vm._v(_vm._s(_vm.$t("influencer_panel.market"))),
            ]),
            _c("p", { staticClass: "market__subtitle" }, [
              _vm._v(_vm._s(_vm.$t("influencer_panel.market_hint"))),
            ]),
          ]),
          _c("b-badge", { attrs: { variant: "light-secondary" } }, [
            _vm._v(_vm._s(_vm.$t("influencer_panel.market_freshness"))),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "market__grid" },
        [
          _vm.positioning && _vm.positioning.percentile
            ? _c(
                "hb-section",
                {
                  attrs: {
                    title: _vm.$t("influencer_panel.positioning"),
                    subtitle: _vm.$t("influencer_panel.positioning_hint"),
                  },
                },
                [
                  _c("div", { staticClass: "market__rank" }, [
                    _c(
                      "span",
                      { staticClass: "market__rank-icon" },
                      [
                        _c("feather-icon", {
                          attrs: { icon: "AwardIcon", size: "20" },
                        }),
                      ],
                      1
                    ),
                    _c("div", [
                      _c("div", { staticClass: "market__rank-value" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("influencer_panel.top_percent", {
                                pct: _vm.positioning.percentile,
                              })
                            ) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "market__rank-hint" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("influencer_panel.among_peers", {
                                count: _vm.positioning.peers,
                              })
                            ) +
                            " "
                        ),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "market__benchmarks" },
                    [
                      _c("benchmark-bar", {
                        attrs: {
                          label: _vm.$t("influencer_panel.conversion_rate"),
                          mine: _vm.positioning.mine.conversion_rate,
                          average: _vm.positioning.platform.conversion_rate,
                          suffix: "%",
                        },
                      }),
                      _c("benchmark-bar", {
                        attrs: {
                          label: _vm.$t("influencer_panel.avg_ticket"),
                          mine: _vm.positioning.mine.avg_ticket_cents,
                          average: _vm.positioning.platform.avg_ticket_cents,
                          money: "",
                        },
                      }),
                      _c("benchmark-bar", {
                        attrs: {
                          label: _vm.$t("influencer_panel.commission"),
                          mine: _vm.positioning.mine.commission_cents,
                          average:
                            _vm.positioning.platform.avg_commission_cents,
                          money: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          _vm.hasTiming
            ? _c(
                "hb-section",
                {
                  attrs: {
                    title: _vm.$t("influencer_panel.timing"),
                    subtitle: _vm.$t("influencer_panel.timing_hint"),
                  },
                },
                [
                  _c("div", { staticClass: "market__block-label" }, [
                    _vm._v(_vm._s(_vm.$t("influencer_panel.weekday"))),
                  ]),
                  _c(
                    "div",
                    { staticClass: "market__bars" },
                    _vm._l(_vm.timing.weekday, function (day) {
                      return _c(
                        "div",
                        {
                          key: "d" + day.bucket,
                          staticClass: "market__bar-col",
                        },
                        [
                          _c("span", { staticClass: "market__bar-pct" }, [
                            _vm._v(_vm._s(day.pct) + "%"),
                          ]),
                          _c("div", { staticClass: "market__bar-track" }, [
                            _c("div", {
                              staticClass: "market__bar-value",
                              style: {
                                height:
                                  _vm.heightOf(day, _vm.timing.weekday) + "%",
                              },
                            }),
                          ]),
                          _c("span", { staticClass: "market__bar-label" }, [
                            _vm._v(_vm._s(_vm.weekdayLabel(day.bucket))),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "market__block-label market__block-label--spaced",
                    },
                    [_vm._v(_vm._s(_vm.$t("influencer_panel.hour_range")))]
                  ),
                  _c(
                    "div",
                    { staticClass: "market__bars" },
                    _vm._l(_vm.timing.hour, function (slot) {
                      return _c(
                        "div",
                        {
                          key: "h" + slot.bucket,
                          staticClass: "market__bar-col",
                        },
                        [
                          _c("span", { staticClass: "market__bar-pct" }, [
                            _vm._v(_vm._s(slot.pct) + "%"),
                          ]),
                          _c("div", { staticClass: "market__bar-track" }, [
                            _c("div", {
                              staticClass: "market__bar-value",
                              style: {
                                height:
                                  _vm.heightOf(slot, _vm.timing.hour) + "%",
                              },
                            }),
                          ]),
                          _c("span", { staticClass: "market__bar-label" }, [
                            _vm._v(_vm._s(_vm.hourLabel(slot.bucket))),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                  _c(
                    "p",
                    { staticClass: "market__note" },
                    [
                      _c("feather-icon", {
                        attrs: { icon: "ClockIcon", size: "13" },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("influencer_panel.timing_note")) +
                          " "
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.opportunities.length
        ? _c(
            "hb-section",
            {
              attrs: {
                title: _vm.$t("influencer_panel.opportunities"),
                subtitle: _vm.$t("influencer_panel.opportunities_hint"),
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "actions",
                    fn: function () {
                      return [
                        _c(
                          "router-link",
                          {
                            staticClass: "market__all",
                            attrs: {
                              to: {
                                name: "influencer-panel-campaigns",
                                query: { tab: "disponiveis" },
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("influencer_panel.see_all")) +
                                " "
                            ),
                            _c("feather-icon", {
                              attrs: { icon: "ChevronRightIcon", size: "14" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                3057108175
              ),
            },
            _vm._l(_vm.opportunities, function (item) {
              return _c(
                "div",
                { key: item.id, staticClass: "market__opportunity" },
                [
                  _c("div", { staticClass: "market__opportunity-identity" }, [
                    _c(
                      "div",
                      { staticClass: "market__opportunity-name" },
                      [
                        _vm._v(" " + _vm._s(item.name) + " "),
                        item.recent_sales > 0
                          ? _c(
                              "b-badge",
                              { attrs: { variant: "light-success" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("influencer_panel.recent_sales", {
                                        count: item.recent_sales,
                                      })
                                    ) +
                                    " "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "market__opportunity-entity" }, [
                      _vm._v(_vm._s(item.legal_entity)),
                    ]),
                  ]),
                  _c("div", { staticClass: "market__opportunity-stat" }, [
                    _c("div", { staticClass: "market__opportunity-label" }, [
                      _vm._v(_vm._s(_vm.$t("influencer_panel.commission"))),
                    ]),
                    _c("div", { staticClass: "market__opportunity-value" }, [
                      _vm._v(_vm._s(_vm.commissionOf(item))),
                    ]),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }